import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  departments: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const departmentsSlice = createSlice({
  name: 'departments',
  initialState: initialState,
  reducers: {
    setDepartment: (state, { payload }) => {
      state.departments = payload?.data?.data || payload?.data || payload || [];
      state.total = payload?.data?.total || payload?.total || 0;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setDepartments: (state, { payload }) => {
      state.departments = payload?.data?.data || payload?.data || payload || [];
      state.total = payload?.data?.total || payload?.total || 0;
      state.is_more = payload?.data?.is_more || payload?.is_more || false;
      state.last_page = payload?.data?.last_page || payload?.last_page || 1;
      state.current_page = payload?.data?.current_page || payload?.current_page || 1;
      state.per_page = payload?.data?.per_page || payload?.per_page || PAGELENGTH;
    },
    setMoreDepartments: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeDepartment: (state, { payload }) => {
      state.error = payload
    },
    clearAllDepartment: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addDepartment = (data, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader && dispatch(setLoader(true))
  try {

    const json = await Api.addDepartment(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setDepartment(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  !disableLoader && dispatch(setLoader(false))
}

export const updateDepartment = (data, itemId, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader && dispatch(setLoader(true))
  try {

    const json = await Api.updateDepartment(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setDepartment(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  !disableLoader && dispatch(setLoader(false))
}

export const removeDepartment = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeDepartment(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setDepartment(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}
export const fetchDepartments = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchDepartments(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setDepartments(result.data.data));
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setDepartments(result.data.data));
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
  !disableLoader && dispatch(setLoader(false))
}

export const fetchDepartmentsByFacility = (facilityId, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchDepartmentsByFacility(facilityId)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setDepartment(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)
  }
  !disableLoader && dispatch(setLoader(false))
}

export const fetchDepartmentsDirect = (disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
    const result = await Api.fetchDepartmentsDirect()
    if (result.status >= 200 && result.status < 300) {
      dispatch(setDepartment(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)
  }
  !disableLoader && dispatch(setLoader(false))
}

export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "subclients/types/departments")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleDepartments = (payload, callback) => async (dispatch) => {
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.removeMultipleDepartments(payload)
    if (json && json.status >= 200 && json.status < 300) {
      callback(true, json.data?.message || "Successfully deleted")
    } else {
      const errorMessage = json?.data?.message || "Failed to delete departments";
      dispatch(setError(json?.data || { message: errorMessage }))
      callback(false, errorMessage)
    }
  } catch (error) {
    console.log("Delete Error:", error)
    callback(false, "An unexpected error occurred during deletion")
  } finally {
    dispatch(setLoader(false))
  }
}

export const { setDepartment, setDepartments, clearAllDepartment, setLoader, setError, setMoreDepartments } = departmentsSlice.actions


export default departmentsSlice.reducer
export const departmentsSelector = state => state.departments